// extracted by mini-css-extract-plugin
export default {"notification-card-wrapper":"_95ERf5Gc9Xvl58a24vB4VA=="};